import { FC } from 'react'

const DefLoginIcons:FC = () => {
  const loginLogo = !['aiforfuture', 'cuhkjc-aiforfuture', 'cuhkjc-aiforfuture-dev'].includes(import.meta.env.VITE_APP_DEPLOYMENT) ? ['/kep-icon.png'] : ['CUHK_AI.png']

  return (
    <>
      {loginLogo.map((img, key) => (
        <img 
          key={key}
          src={img} alt={img} />
      ))}
    </>
  )
}

export default DefLoginIcons